export default "__VITE_ASSET__CRW8VGXR__"